import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=64e2cf60&scoped=true&"
import script from "./EmployeeForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=64e2cf60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2cf60",
  null
  
)

export default component.exports